import type { SxProps, Theme } from '@mui/material/styles'
import { SP_SIGNUP_NAVY, SP_SIGNUP_YELLOW, SP_SIGNUP_YELLOW_HOVER } from './signupShareTheme'

export const welcomePageSx: SxProps<Theme> = {
  height: '100dvh',
  maxHeight: '100dvh',
  bgcolor: '#FFFAF4',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  overflow: 'hidden',
}

export const welcomeScrollSx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  px: { xs: 1.5, sm: 3 },
  py: { xs: 3, sm: '48px' },
  boxSizing: 'border-box',
}

export const welcomeHeroGlowSx: SxProps<Theme> = {
  position: 'absolute',
  pointerEvents: 'none',
  borderRadius: '50%',
  filter: 'blur(100px)',
  zIndex: 0,
}

export const welcomeHeroGlowYellowSx: SxProps<Theme> = {
  ...welcomeHeroGlowSx,
  width: { xs: 149, md: 280 },
  height: { xs: 149, md: 280 },
  bgcolor: '#FFEA9F',
  top: { xs: 36, md: 24 },
  left: '50%',
  transform: 'translateX(-50%)',
}

export const welcomeHeroGlowBlueSx: SxProps<Theme> = {
  ...welcomeHeroGlowSx,
  width: { xs: 100, md: 180 },
  height: { xs: 100, md: 180 },
  bgcolor: '#ABBDFF',
  top: { xs: 36, md: 8 },
  left: '50%',
  transform: 'translateX(calc(-50% - 8px))',
}

export const welcomeInnerSx: SxProps<Theme> = {
  width: '100%',
  maxWidth: 1080,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  zIndex: 1,
}

export const welcomeLogoSx: SxProps<Theme> = {
  height: { xs: 80, sm: 96 },
  width: 'auto',
  maxWidth: '100%',
  objectFit: 'contain',
  mb: { xs: 2.5, sm: '40px' },
}

export const welcomeKickerSx: SxProps<Theme> = {
  m: 0,
  fontSize: 14,
  letterSpacing: '0.4px',
  fontWeight: 400,
  color: '#5C7695',
  textTransform: 'uppercase',
  lineHeight: '24px',
}

export const welcomeHeadlineSx: SxProps<Theme> = {
  m: 0,
  mt: 1,
  fontWeight: 800,
  fontSize: { xs: 24, sm: 40 },
  lineHeight: { xs: '32px', sm: '48px' },
  color: SP_SIGNUP_NAVY,
  textAlign: 'center',
  letterSpacing: '-0.96px',
}

export const welcomeRewardLineSx: SxProps<Theme> = {
  display: 'block',
  color: 'inherit',
}

export const welcomeRewardSx: SxProps<Theme> = {
  display: 'inline',
  color: SP_SIGNUP_YELLOW,
}

export const welcomeSubtitleSx: SxProps<Theme> = {
  m: 0,
  mt: 2,
  maxWidth: 520,
  color: 'rgba(15, 23, 42, 0.6)',
  fontSize: { xs: 13, sm: 16 },
  lineHeight: { xs: '20px', sm: '24px' },
  textAlign: 'center',
  letterSpacing: { xs: '-0.96px', sm: '-0.2px' },
}

export const welcomeStartSx: SxProps<Theme> = {
  mt: { xs: 2.5, sm: 3 },
  px: 3,
  py: 2,
  width: { xs: '100%', sm: 354 },
  maxWidth: 354,
  minHeight: 56,
  borderRadius: '8px',
  bgcolor: SP_SIGNUP_YELLOW,
  color: SP_SIGNUP_NAVY,
  fontWeight: 500,
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': { bgcolor: SP_SIGNUP_YELLOW_HOVER, color: SP_SIGNUP_NAVY, boxShadow: 'none' },
  '&.Mui-disabled': {
    bgcolor: SP_SIGNUP_YELLOW,
    color: SP_SIGNUP_NAVY,
    opacity: 0.55,
  },
}

export const welcomeAboutSx: SxProps<Theme> = {
  width: '100%',
  mt: 3,
  px: { xs: 2, sm: 3 },
  py: { xs: 2, sm: 2.5 },
  borderRadius: '16px',
  bgcolor: '#EAF2FC',
  display: 'flex',
  gap: { xs: '14px', sm: '20px' },
  alignItems: 'center',
  textAlign: 'left',
}

export const welcomeAboutIconWrapSx: SxProps<Theme> = {
  width: { xs: 48, sm: 64 },
  height: { xs: 48, sm: 64 },
  borderRadius: '50%',
  bgcolor: '#D6E6FA',
  color: '#1F3B66',
  display: 'grid',
  placeItems: 'center',
  flexShrink: 0,
  '& svg': { width: { xs: 24, sm: 30 }, height: { xs: 24, sm: 30 } },
}

export const welcomeAboutTextSx: SxProps<Theme> = {
  fontSize: { xs: 13, sm: 14 },
  lineHeight: { xs: '19.5px', sm: '21px' },
  color: '#475569',
}

export const welcomeTrustWrapSx: SxProps<Theme> = {
  mt: 3,
  width: '100%',
  maxWidth: { xs: 390, md: '100%' },
}

export const welcomeTrustGridSx: SxProps<Theme> = {
  display: { xs: 'grid', md: 'none' },
  gridTemplateColumns: '1fr 1fr',
  gap: '10px',
  width: '100%',
  pb: '28px',
}

export const welcomeTrustCardSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '9px',
  minHeight: 46,
  px: '11px',
  py: '10px',
  borderRadius: '12px',
  border: '1.1px solid #E6EBF2',
  color: '#334155',
  fontSize: 12,
  lineHeight: '18px',
  fontWeight: 600,
  '& img': { display: 'block', flexShrink: 0 },
}

export const welcomeTrustDesktopSx: SxProps<Theme> = {
  display: { xs: 'none', md: 'flex' },
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px',
  width: '100%',
}

export const welcomeTrustRowSx: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center',
  columnGap: 0,
  rowGap: '10px',
  color: '#334155',
  fontSize: 12,
  lineHeight: '16px',
  fontWeight: 600,
}

export const welcomeTrustItemSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  whiteSpace: 'nowrap',
  '& img': { display: 'block', flexShrink: 0 },
}

export const welcomeTrustDotSx: SxProps<Theme> = {
  width: 3,
  height: 3,
  borderRadius: '50%',
  bgcolor: '#94A3B8',
  mx: '16px',
  flexShrink: 0,
}

export const welcomeHowSectionSx: SxProps<Theme> = {
  width: '100%',
  mt: { xs: 0, md: 5 },
  px: { xs: 2, sm: 4 },
  pt: { xs: '27px', sm: 4 },
  pb: { xs: 3, sm: 4 },
  borderRadius: '20px',
  bgcolor: '#F3F6FB',
}

export const welcomeHowTitleSx: SxProps<Theme> = {
  m: 0,
  fontWeight: 800,
  fontSize: { xs: 26, sm: 28 },
  lineHeight: { xs: '32.5px', sm: '36px' },
  letterSpacing: '-0.5px',
  color: '#0F1B33',
  textAlign: 'center',
}

export const welcomeHowSubtitleSx: SxProps<Theme> = {
  m: 0,
  mt: 1,
  mb: 3,
  color: '#475569',
  fontSize: 14,
  lineHeight: '21px',
  textAlign: 'center',
}

export const welcomeHowGridSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  alignItems: 'stretch',
  gap: { xs: 0, md: 1.5 },
}

export const welcomeHowColSx: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
}

export const welcomeStepHeaderSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  mb: 1.25,
  px: '3px',
}

export const welcomeStepBadgeSx: SxProps<Theme> = {
  width: 32,
  height: 32,
  borderRadius: '16px',
  bgcolor: '#DCE8FB',
  color: '#1D5FD1',
  fontWeight: 800,
  fontSize: 14,
  lineHeight: '21px',
  display: 'grid',
  placeItems: 'center',
  flexShrink: 0,
}

export const welcomeStepTitleSx: SxProps<Theme> = {
  fontWeight: 700,
  color: '#0F1B33',
  fontSize: 16,
  lineHeight: '24px',
}

export const welcomeStepCardSx: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  height: { xs: 'auto', md: '100%' },
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  bgcolor: '#FFFFFF',
  borderRadius: '14px',
  p: 2,
  border: '1.1px solid rgba(230, 235, 242, 0.7)',
  boxShadow: '0px 2px 4px rgba(15, 27, 51, 0.07)',
}

export const welcomeHowArrowSx: SxProps<Theme> = {
  display: 'flex',
  color: '#94A3B8',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  transform: { xs: 'rotate(90deg)', md: 'none' },
  alignSelf: 'center',
  height: { xs: 45, md: 'auto' },
  pt: { xs: 0, md: 0 },
}

export const welcomeBrandGridSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '10px',
  width: '100%',
  flex: 'none',
}

export const welcomeBrandCardSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: 91,
  p: '5px',
  gap: '7px',
  borderRadius: '12px',
  border: '1.1px solid #E6EBF2',
  bgcolor: '#FFFFFF',
}

export const welcomeBrandCardSelectedSx: SxProps<Theme> = {
  borderColor: '#E8680C',
}

export const welcomeBrandTileSx: SxProps<Theme> = {
  width: '100%',
  height: 52,
  minHeight: 52,
  borderRadius: '8px',
  display: 'grid',
  placeItems: 'center',
  overflow: 'hidden',
  flexShrink: 0,
}

export const welcomeBrandCaptionSx: SxProps<Theme> = {
  fontSize: 10,
  fontWeight: 600,
  color: '#475569',
  lineHeight: '12px',
  textAlign: 'center',
  pb: '2px',
}

export const welcomeBrandLogoSx: SxProps<Theme> = {
  width: 'auto',
  height: 32,
  maxWidth: '78%',
  objectFit: 'contain',
  display: 'block',
}

export const welcomePrivacySx: SxProps<Theme> = {
  width: '100%',
  mt: { xs: 2.5, md: 2.5 },
  px: 2,
  py: 2.5,
  borderRadius: '16px',
  bgcolor: '#EDF7F0',
  display: 'flex',
  gap: '14px',
  alignItems: 'flex-start',
}

export const welcomePrivacyIconWrapSx: SxProps<Theme> = {
  width: 48,
  height: 48,
  borderRadius: '24px',
  bgcolor: '#D5EEDD',
  display: 'grid',
  placeItems: 'center',
  flexShrink: 0,
}

export const welcomeFooterSx: SxProps<Theme> = {
  mt: 3.5,
  pt: { xs: '23px', md: 0 },
  px: { xs: 2, md: 0 },
  pb: { xs: '28px', md: 0 },
  width: '100%',
  borderTop: { xs: '1.1px solid #E6EBF2', md: 'none' },
  color: '#5B6B82',
  fontSize: 11,
  lineHeight: '16.5px',
  textAlign: 'center',
}

export const welcomeFooterLinkSx: SxProps<Theme> = {
  color: '#475569',
  fontSize: 11,
  fontWeight: 500,
  lineHeight: '16.5px',
  textDecoration: 'none',
  minHeight: 44,
  display: 'inline-flex',
  alignItems: 'center',
  px: '2px',
  '&:hover': { textDecoration: 'underline' },
}

export const welcomeFooterSepSx: SxProps<Theme> = {
  color: '#5B6B82',
  px: 0.75,
  fontSize: 16,
  lineHeight: '24px',
}
